import React from "react";
import { getUserSessionDetails } from "../../services/common.service";

export type Role = "admin" | "group leader" | "participant" | string;

type AuthorizedProps = {
  /** array of allowed roles */
  allowed: Role[];
  children: React.ReactNode;
};

export default function Authorized({ allowed, children }: AuthorizedProps) {
  // Make sure getUserSessionDetails() is typed (see note below).
  const role = getUserSessionDetails()?.role;
  const ok = typeof role === "string" && allowed.includes(role as Role);

  return ok ? <>{children}</> : null;
}
